<db-cdn-general class="mb20" [isNameServer]="isNameServer"></db-cdn-general>

<db-cdn-feature-stack class="mb10"></db-cdn-feature-stack>

<db-cdn-clear-cache></db-cdn-clear-cache>
